import Vue from 'vue'

const _eventBus = new Vue()

Object.defineProperties(Vue.prototype, {
  eventBus: {
    get () {
      return _eventBus
    }
  },
  $eventBus: {
    get () {
      return _eventBus
    }
  }
})
